export default "__VITE_ASSET__f221bbb7__"